var map = {
	"./brush.png": 60,
	"./brush@2x.png": 61
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 179;



//////////////////
// WEBPACK FOOTER
// ./img/brush ^\.\/brush.*\.png$
// module id = 179
// module chunks = 3